import { Link, useParams } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieBrowser from '@/components/feature/MovieBrowser';
import PageHeader from '@/components/feature/PageHeader';
import { usePageMeta } from '@/hooks/usePageMeta';

const typeConfig: Record<string, { title: string; desc: string }> = {
  movie: {
    title: '电影专区',
    desc: '汇聚院线热映、经典佳片与高分电影，涵盖动作、科幻、爱情、悬疑等多种类型，总有一部合你口味。',
  },
  tv: {
    title: '电视剧专区',
    desc: '热门剧集同步追更，古装、都市、悬疑、青春题材一应俱全，剧集介绍与更新进度清晰可见。',
  },
};

const subTags = [
  { label: '动作', to: '/list/action' },
  { label: '爱情', to: '/list/love' },
  { label: '科幻', to: '/list/scifi' },
  { label: '喜剧', to: '/list/comedy' },
  { label: '悬疑', to: '/list/suspense' },
  { label: '古装', to: '/list/history' },
  { label: '小众佳作', to: '/list/niche' },
];

export default function Category() {
  const { type = 'movie' } = useParams();
  const config = typeConfig[type];
  const title = config ? config.title : '影视分类';
  const desc = config ? config.desc : '按分类浏览影视作品。';

  usePageMeta(`${title} - 红桃影视`, desc);

  if (!config) {
    return (
      <div className="px-4 md:px-6 lg:px-10 py-20 text-center">
        <h1 className="text-2xl font-bold text-foreground-950">分类不存在</h1>
        <p className="mt-3 text-foreground-600">你访问的分类暂时不存在或已下线。</p>
        <Link
          to="/"
          className="inline-flex mt-6 px-6 h-11 items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
      </div>
    );
  }

  const list = movies.filter((m) => m.type === type);

  return (
    <div className="pb-6">
      <PageHeader
        title={title}
        description={desc}
        items={[{ label: config.title }]}
      />

      <div className="px-4 md:px-6 lg:px-10">
        <div className="mt-6 flex flex-wrap items-center gap-2">
          <span className="text-sm text-foreground-500 mr-1">
            <i className="ri-price-tag-3-line mr-1" />
            子分类：
          </span>
          {subTags.map((tag) => (
            <Link
              key={tag.to}
              to={tag.to}
              className="px-3 py-1.5 rounded-full text-xs md:text-sm bg-secondary-100/70 text-secondary-900 hover:bg-primary-500/20 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              {tag.label}
            </Link>
          ))}
        </div>

        <div className="mt-6">
          <MovieBrowser movies={list} />
        </div>
      </div>
    </div>
  );
}